import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';

export const DemGrossSalesPerspective = () => {
  const views = [
    {
      name: 'Gross Sales',
      dims: ['PERIOD', 'PROD'],
      kpis: ['UNITS', 'GROSS_SALES', 'AVG_GROSS_PRICE'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PERIOD: ['YEAR', 'QTR', 'MON'],
      },
    },
  ];

  return <EntityPerspective views={views} />;
};
